<template>
  <div class="inputSelect">
    <Col :span="span">
      <FormItem :label="label" :prop="prop" :required="required" style="width: 100%" :label-width="labelWidth">
        <!-- 文本输入框 -->
        <Input 
          :value="value"
          @on-change="$emit('input', $event.target.value)"
          v-show="type=='input'"
          :disabled="disabled"
          :readonly="readonly"
          :title="title"
          :number="number"
          :type="dataType"
          :placeholder="placeholder">
        </Input>
        <!-- 日期输入框 -->
        <DatePicker 
          type="date"
          :value="value" 
          @on-change="onChange($event)"
          v-show="type=='date'" 
          :readonly="disabled" 
          :disabled="disabled">
        </DatePicker>
        <!-- 日期时间输入框 -->
        <DatePicker
          type="datetime"
          format="yyyy-MM-dd HH:mm" 
          :value="value" 
          @on-change="onChange($event)"
          v-show="type=='datetime'" 
          :readonly="disabled" 
          :disabled="disabled">
        </DatePicker>
        <!-- 下拉选择框 -->
        <Select 
          :value="value" 
          @on-change="onChange" 
          v-show="type=='select'" 
          :disabled="disabled">
          <Option v-for="(item,index) in options" :value="item[rangekey]" :key="index">
            {{ item[rangekey] }}
          </Option>
        </Select>
        <!-- 多选下拉选择框 -->
        <Select
          :value="arrayValue" 
          @on-change="arrayChange" 
          v-show="type=='multipleSelect'" 
          :disabled="disabled"
          :multiple="true">
          <Option v-for="(item,index) in options" :value="item[rangekey]" :key="index">
            {{ item[rangekey] }}
          </Option>
        </Select>
        <span v-show="type=='text'">{{content}}</span>
      </FormItem>
    </Col>
  </div>
</template>

<script>
export default {
  name: 'inputSelect',
  props: {
    prop: String,
    span: String,
    label: String,
    value: String,
    type: {
      type: String,
      default: 'input'
    },
    dataType: String,
    options: Array,
    content: String,
    disabled: Boolean,
    title: String,
    number: Boolean,
    readonly: Boolean,
    required: Boolean,
    rangekey: {
      type: String,
      default: 'value'
    },
    labelWidth: Number,
    multiple: {
      type: Boolean,
      default: false
    },
    arrayValue: Array,
    placeholder: String
  },
  methods: {
    onChange(e) {
      this.$emit('input', e)
      this.$emit('onChange', e)
    },
    arrayChange(e) {
      this.$emit('arrayChange', e)
    }
  }
}
</script>

<style lang="less" scoped>
/deep/.ivu-form-item {
  margin-bottom: 10px;
}
/deep/.ivu-form-item-label {
  padding-left: 15px !important;
  white-space: nowrap;
}
</style>
